function closeAll(except) {
	document.querySelectorAll("[data-header-toggle][aria-expanded='true']").forEach((toggle) => {
		if (toggle === except) return;
		toggle.setAttribute("aria-expanded", "false");
		document.getElementById(toggle.getAttribute("aria-controls"))?.setAttribute("hidden", "");
	});
}

function initHeaderToggles() {
	const toggles = document.querySelectorAll("[data-header-toggle]");
	if (!toggles.length) return;

	toggles.forEach((toggle) => {
		const panel = document.getElementById(toggle.getAttribute("aria-controls"));
		if (!panel) return;

		toggle.addEventListener("click", () => {
			const open = toggle.getAttribute("aria-expanded") !== "true";
			closeAll(toggle);
			toggle.setAttribute("aria-expanded", String(open));
			panel.toggleAttribute("hidden", !open);
			if (open) panel.querySelector("input, a")?.focus();
		});
	});

	document.addEventListener("click", (event) => {
		if (!event.target.closest(".header-dropdown")) closeAll();
	});

	document.addEventListener("keydown", (event) => {
		if (event.key !== "Escape") return;
		const open = document.querySelector("[data-header-toggle][aria-expanded='true']");
		closeAll();
		open?.focus();
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initHeaderToggles);
} else {
	initHeaderToggles();
}
